




















































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import dialogComp from '@/components/dialog/index.vue';
import copy from 'copy-to-clipboard';
import shareDialog from '../share/index';
import { shareToPlatform } from '@/utils/hybird';
import { Button } from 'mint-ui';
import checkBox from '../../checkbox.vue';
import loginDialog from '../login/index'
import policyDialog from '../policy/index'
import qs from 'qs'
@Component<VBANNER>({
  components: {
    dialogComp,
    checkBox,
    'mt-button': Button,
  },
  methods: {
    goNext: () => {},
    chuandi: () => {},
  },
})
export default class VBANNER extends Vue {
  public tipType: number = 0; /* 0是已参与过活动，1是未中奖 */
  public tipError: string = '';
  public giftTip: string = '';
  public copyText: string = '';
  public params: any = {
    name: '',
    phone: '',
    qq: '',
    idCard: '',
  };
  public showPolicy(){
    policyDialog({})
  }
  public goNext2: any = () => {
    this.close();
    (this as any).goNext();
  };
  public bgList: any = {
    '500YUAN':
      'https://source.qunarzz.com/site/images/wns/20220726-shijianchen-peace-1.png',
    '100YUAN':
      'https://source.qunarzz.com/site/images/wns/20220726-shijianchen-peace-2.png',
    '800Q':
      'https://source.qunarzz.com/site/images/wns/20220726-shijianchen-peace-3.png',
    '200Q':
      'https://source.qunarzz.com/site/images/wns/20220726-shijianchen-peace-4.png',
    '50Q':
      'https://source.qunarzz.com/site/images/wns/20220726-shijianchen-peace-5.png',
    '10Q':
      'https://source.qunarzz.com/site/images/wns/20220726-shijianchen-peace-6.png',
    THANKS: 'https://source.qunarzz.com/site/images/wns/20220727-shijianchen-thanks.png',
  };
  public chuandi2: any = () => {
    this.close();
    (this as any).chuandi();
  };
  public checked: boolean = false;
  public verifyForm() {
    return new Promise((resolve: any) => {
      var reg = /^1[3456789]\d{9}$/gi;
      let dialog = this.$dialog as any;
      if (!this.checked) {
        dialog.alert({
          message: '请勾选个人信息授权声明',
        });
      } else if (this.params.name == '') {
        dialog.alert({
          message: '请输入姓名',
        });
      } else if (this.params.phone == '') {
        dialog.alert({
          message: '请输入手机号',
        });
      } else if (!reg.test(this.params.phone)) {
        dialog.alert({
          message: '请输入正确的手机号',
        });
      } else if (this.params.idCard == '') {
        dialog.alert({
          message: '身份证不能为空',
        });
      } else {
        resolve();
      }
    });
  }
  public verifyForm2() {
    return new Promise((resolve: any) => {
      var reg = /^1[3456789]\d{9}$/gi;
      let dialog = this.$dialog as any;
      if (!this.checked) {
        dialog.alert({
          message: '请勾选个人信息授权声明',
        });
      } else if (this.params.name == '') {
        dialog.alert({
          message: '请输入姓名',
        });
      }  else if (this.params.qq == '') {
        dialog.alert({
          message: '请输入qq号',
        });
      } else if (this.params.phone == '') {
        dialog.alert({
          message: '请输入手机号',
        });
      } else if (!reg.test(this.params.phone)) {
        dialog.alert({
          message: '请输入正确的手机号',
        });
      } else {
        resolve();
      }
    });
  }
  public submit() {
    if (this.giftTip == '500YUAN' || this.giftTip == '100YUAN') {
      this.verifyForm().then(() => {
        (this as any).$http({
          url: '/commonly/rePrzie?'+qs.stringify({
            name:this.params.name,
            phone:this.params.phone,
            id:this.copyText,
            IdCard:this.params.idCard
          }),
          type: 'get',
          data: {
            
          },
          config: { formType: true },
          login: loginDialog,
          success: (res:any) => {
            (this as any).$dialog.alert({
              message: '提交成功',
            });
            this.callback(()=>{
              this.close();
            });
          },
        });
      });
    }else{
      this.verifyForm2().then(() => {
        (this as any).$http({
          url: '/commonly/rePrzie?'+qs.stringify({
            qq:this.params.qq,
            id:this.copyText,
            phone:this.params.phone,
            name:this.params.name
          }),
          type: 'get',
          data: {
            
          },
          config: { formType: true },
          login: loginDialog,
          success: (res:any) => {
            (this as any).$dialog.alert({
              message: '提交成功',
            });
            this.callback(()=>{
              this.close();
            });
          },
        });
      });
    }
  }
  public share() {
    shareToPlatform(
      () => {},
      () => {
        shareDialog({});
      },
    );
  }
  public handleCopy() {
    copy(this.copyText);
    (this as any).$dialog.alert({
      message: '复制成功',
    });
  }
  public thanksImgs: string[] = [
    'https://s.qunarzz.com/srmweb/qunaradv/changma202201/dialog/10.png',
    'https://s.qunarzz.com/srmweb/qunaradv/changma202201/dialog/11.png',
    'https://s.qunarzz.com/srmweb/qunaradv/changma202201/dialog/12.png',
    'https://s.qunarzz.com/srmweb/qunaradv/changma202201/dialog/13.png',
  ];
  public getCurrentThankImg() {
    return this.thanksImgs[Math.floor(Math.random() * this.thanksImgs.length)];
  }
  public show() {
    (this.$refs.dialog as any).show();
  }
  public close() {
    (this.$refs.dialog as any).close();
  }
  public goUrl() {
    location.href =
      'https://event.qunar.com/qm/qunargiftnew/index.htm?activityNo=tongyongh5&bdsource=tongyong';
  }
  public callback:any = ()=> {}
  public goLottery() {
    this.callback();
    this.close();
  }
}
